const arrayValue = (val: any) => (!val ? [] : Array.isArray(val) ? val : [val]);

export default arrayValue;
